import http from 'axios'

import { authApiURL as API_URL } from '../../utils'

const getSearchParams = () => {
  const action = 'getBookingSearchParams'
  return http.get(API_URL, { params: { action: action } }).then(res => res.data)
}

const getSearchResults = () => {
  const action = 'getBookingSearchResults'
  return http.get(API_URL, { params: { action: action } }).then(res => res.data)
}

const search = (params) => {
  const url = API_URL + '?action=runBookingSearch'
  return http.post(url, params).then(res => res.data)
}

const issueContract = ({ bookingId }) => {
  const params = {
    action: 'issueContract',
    booking: '' + bookingId
  }
  return http.get(API_URL, { params: params }).then(res => res.data)
}

const issueInvoice = ({ bookingId }) => {
  const params = {
    action: 'issueInvoice',
    booking: bookingId
  }
  return http.get(API_URL, { params: params }).then(res => res.data)
}
const getBooking = ({ bookingId }) => {
  const params = {
    action: 'booking',
    id: '' + bookingId
  }
  return http.get(API_URL, { params: params }).then(res => res.data)
}

const checkVatNo = ({ no }) => {
  const params = {
    action: 'checkVatNo',
    vat_no: '' + no
  }
  return http.get(API_URL, { params: params }).then(res => res.data)
}

const issueReceipt = ({ booking, invoice, amount, currency }) => {
  const params = {
    action: 'issueReceipt',
    booking: booking,
    invoice: invoice,
    amount: amount,
    currency: currency
  }
  return http.get(API_URL, { params: params }).then(res => res.data)
}

const savePax = ({ booking, pax }) => {
  const params = {
    action: 'updateBookingPax'
  }
  const post = { booking, pax }

  return http.post(API_URL, post, { params: params }).then(res => res.data)
}

const getISOCountries = () => http.get(API_URL, { params: { action: 'getISOCountries' } }).then(res => res.data)

export {
  getISOCountries,
  getSearchParams,
  getSearchResults,
  search,
  getBooking,
  issueContract,
  issueInvoice,
  issueReceipt,
  checkVatNo,
  savePax
}
